// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/tables/data/authorsTableData";
import { CircularProgress } from "@mui/material";
import ResizableDataGrid from "components/ResizableDataGrid";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";

import axios from "axios";

const DataGrid = ResizableDataGrid;

function AllArtists() {
  const auth = localStorage.getItem("authToken");

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const columns = [
    {
      field: "artist_id",
      headerName: "ID",
      width: 100,
    },
    {
      field: "name",
      headerName: "Name",
      width: 400,
    },

    {
      field: "onclick",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <strong>
          <MDButton
            variant="contained"
            size="small"
            color="error"
            onClick={() => {
              setArtistToDelete({
                artist_id: params.row.artist_id,
                name: params.row.name,
              });
              setDeleteDialogOpen(true);
            }}
          >
            Delete
          </MDButton>
        </strong>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [artistToDelete, setArtistToDelete] = useState(null);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/product/getallartist`,
        null,
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
      if (res.data.success) {
        setUsers(Object.values(res.data.data).map((item) => item));
      } else {
        if (res.data.data === "no record found") {
          enqueueSnackbar(res.data.data, { variant: "info" });
        } else {
          console.log("Error Occurred");
          enqueueSnackbar(res.data.message, { variant: "error" });
        }
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Error occurred. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteArtist = async (artistId) => {
    setLoading(true);
    await axios({
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/admin/product/deleteartist`,
      data: { artistId },
      headers: {
        Authorization: `Bearer ${auth}`,
      },
    })
      .then((res) => {
        if (res.data.success) {
          enqueueSnackbar("Artist Deleted successfully", {
            variant: "success",
          });
          setDeleteDialogOpen(false);
          setArtistToDelete(null);
          getUsers();
        } else {
          enqueueSnackbar("Operation failed", { variant: "error" });
        }
      })
      .catch((err) => {
        console.error("Error occurred:", err);
        enqueueSnackbar("Error occurred. Please try again.", {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setArtistToDelete(null);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-artist-dialog-title"
        aria-describedby="delete-artist-dialog-description"
      >
        <DialogTitle id="delete-artist-dialog-title">
          Delete Artist
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-artist-dialog-description">
            Are you sure you want to delete{" "}
            <strong>{artistToDelete?.name ?? "this artist"}</strong>? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <MDButton
            variant="outlined"
            color="dark"
            onClick={handleCloseDeleteDialog}
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="error"
            onClick={() =>
              artistToDelete && handleDeleteArtist(artistToDelete.artist_id)
            }
            autoFocus
          >
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} justifyContent="flex-start">
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Artists
                </MDTypography>
                <MDBox className="ticket_btnsHeaderCont">
                  <MDButton
                    onClick={() => navigate("/artists/add")}
                    variant="outlined"
                    color="white"
                  >
                    Add Artist
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {loading ? (
                  <CircularProgress
                    style={{
                      marginTop: "80px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh", // Ensures the container takes the full height of the viewport
                    }}
                    color="inherit"
                  />
                ) : (
                  <>
                    {users && (
                      <MDBox sx={{ height: 400 }} p={2}>
                        <DataGrid
                          getRowId={(row) => row.artist_id}
                          rows={users}
                          columns={columns}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 100,
                              },
                            },
                          }}
                         
                          disableRowSelectionOnClick
                        />
                      </MDBox>
                    )}
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AllArtists;
